<template>
  <div class="home">
    <pageTop></pageTop>
    <swiper
        :options="swiperOption"
        ref="swiper"
        @mouseover.native="swiperMouseover"
        @mouseout.native="swiperMouseout"
    >
      <swiper-slide v-for="(item, index) in imgList" :key="index">
        <img  :src="item.imgSrc" class="bannerImg" />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination">
          <span
              v-for="(item, index) in imgList"
              :class="['dot', index == swiper.realIndex?'cur':'']"
              :key="index">
          </span>
      </div>
      <div
          :class="['swiper-button-prev', showArrows?'show': '']"
          slot="button-prev"
          @click="slidePrev"
      >
      </div>
      <div
          :class="['swiper-button-next', showArrows?'show': '']"
          slot="button-next"
          @click="slideNext"
      >
      </div>
    </swiper>

    <!-- 字节生活 -->
    <div class="byteLife content-item-block"         v-for="item in aboutList" >
      <h1 class="byteLife-title">{{item.title}}</h1>
      <div class="block-item block-item-one">
        <div class="block-item-column block-item-column-text">
          <h2 class="block-item-column-title">关于东方地保</h2>
          <p class="content-item-desc">{{item.companyIntro}}</p>
          <div class="content">
            <div class="content-item">
              <h2 class="content-item-title">公司愿景</h2>
              <p class="content-item-desc">{{item.companyVision}}</p>
            </div>
            <div class="content-item">
              <h2 class="content-item-title">团队介绍</h2>
              <p class="content-item-desc">{{item.teamIntro}}</p>
            </div>
            <div class="content-item">
              <h2 class="content-item-title">公司文化</h2>
              <p class="content-item-desc">{{item.companyCulture}}</p>
            </div>
          </div>
        </div>
        <div class="block-item-column block-item-column-image">
          <img :src="item.companyPicture" alt />
        </div>
      </div>

      <div class="block-item block-item-one">
        <div class="block-item-column block-item-column-text">
          <h2 class="block-item-column-title">核心业务</h2>
          <div class="content">
            <div class="content-item">
              <h2 class="content-item-title">品牌策略与设计</h2>
              <p class="content-item-desc">为客户提供品牌定位、品牌形象设计、VI设计等全方位的品牌策略服务。</p>
            </div>
            <div class="content-item">
              <h2 class="content-item-title">数字营销</h2>
              <p class="content-item-desc">包括搜索引擎优化（SEO）、搜索引擎营销（SEM）、社交媒体营销（SMM）、内容营销等，帮助客户在数字化时代抢占市场先机。</p>
            </div>
            <div class="content-item">
              <h2 class="content-item-title">影视制作</h2>
              <p class="content-item-desc">提供广告片、宣传片、微电影等影视作品的策划、拍摄与制作服务，助力客户通过视觉传播提升品牌影响力。</p>
            </div>
            <div class="content-item">
              <h2 class="content-item-title">公关活动</h2>
              <p class="content-item-desc">策划并执行各类线下活动、公关活动、新闻发布会等，增强品牌的市场影响力与公信力。</p>
            </div>

            <div class="content-item">
              <h2 class="content-item-title">数据分析与洞察</h2>
              <p class="content-item-desc">通过大数据分析，提供市场调研、消费者洞察等服务，帮助客户制定精准的营销策略。</p>
            </div>
          </div>
        </div>
        <div class="block-item-column block-item-column-image">
          <img src="@/assets/images/img.png" alt />
        </div>
      </div>
    </div>

    <!-- 员工故事 -->
    <div class="staffStory content-item-block">
      <h2 class="title">和公司同行</h2>
      <ul class="staffStory-list clearfix">
        <router-link
          tag="li"
          :to="`/staff-stories/${item.id}`"
          v-for="item in staffStories"
          :key="item.id"
          class="staffStory-item"
        >
          <div class="avatar">
            <img width="100%" :src="item.avatar" alt srcset />
          </div>
          <div class="text">
            <h2 class="title">{{ item.title }}</h2>
            <div class="desc">{{ item.name }}&nbsp;|&nbsp;{{ item.department }}</div>
            <p class="remark">{{ item.remark }}</p>
          </div>
          <div class="circular-button">→</div>
        </router-link>
      </ul>
    </div>
    <Footer ></Footer>

  </div>
</template>

<script>
// @ is an alias to /src
import { watchScrollDirection } from "@/helper/utilities.js";
import Footer from "@/components/footer.vue";
import pageTop from "@/components/pageTop/pageTop";
import home, {getStaffStories,getAbout} from "@/api/home";

export default {
  name: "home",
  components: {pageTop, Footer},
  data() {
    return {
      productLayerVisible: true,
      search: "",
      products: [],
      jobCategories: [],
      byteStandards: [],
      byteStandardActiveIndex: 0,
      staffStories: [],
      aboutList: [],
      imgList: [
        { imgSrc: 'https://juanxiuhe.oss-cn-beijing.aliyuncs.com/b111ab5e1ac818b86f0379a91d6d9e57.jpg' },
        { imgSrc: 'https://juanxiuhe.oss-cn-beijing.aliyuncs.com/df0edc62dda58b0c109dd7a82e31221f.jpg'  }],
      currentPage: 1,
      swiperOption: {//swiper3
        // 开启自动播放
        autoplay: {
          delay: 3000, // 自动播放间隔时间，单位为毫秒
          disableOnInteraction: false, // 用户操作后是否停止自动播放，默认为true，设为false则不会停止
        },
        // 其它配置项，如 effect, loop 等，根据需要添加
        loop: true, // 启用无限循环
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiper: '',
      showArrows: false
    };
  },
  created() {

  },
  methods: {

    onScrollRightAnimationEnd() {
      this.productLayerVisible = false;
    },
    scrollDown() {

      window.scrollBy(0, 1000);
      // this.$refs.product.scrollIntoView({
      //   behavior: "smooth",
      //   block: "start"
      // });
    },
    searchJobs(keyword) {
      this.$router.push({ name: "jobs", params: { keyword } });
    },
    jumpToDetail(item) {
      this.$router.push({ name: "products", params: item });
    },
    truncatedString(str){
      return str.split('。')
    },
    swiperMouseover() {
      this.showArrows = true;
    },
    swiperMouseout() {
      this.showArrows = false;
    },
    slidePrev() {
      this.swiper.slidePrev();
    },
    slideNext() {
      this.swiper.slideNext();
    },

  },
  mounted() {
    this.swiper = this.$refs.swiper.swiperInstance;
    const intervalId = setInterval(this.slideNext, 2000);


    home.getStaffStories({orderBy:"createTime"}).then(rs => {
      this.staffStories = rs.data
    })


    home.getAbout({orderBy:"createTime"}).then(rs => {
      this.aboutList = rs.data
    })
  }

};
</script>

<style>
/* @import "../assets/transition.css";  */
</style>

<style lang="less" scoped>

</style>
